import React from 'react'

import { Box } from '@mui/material';

import Alert from '@mui/material/Alert';
import __t from "../../../lib/traduzioni";
import useBSSLogger from '../../../hooks/useBSSLogger';
import BSSSnackbar from '../../form/BSSSnackbar';

const {logger} = useBSSLogger();


const ErroriAddizionali = ({erroriRicalcolo, preventivo, setErroriRicalcolo, }) => {
    return (
        <Box >
            {((erroriRicalcolo[preventivo.price.id] ?? []).length !== 0) && (
                <BSSSnackbar open={((erroriRicalcolo[preventivo.price.id] ?? []).length !== 0)}
                    onClose={() => setErroriRicalcolo({})}
                >
                    <Alert severity={"error"}>
                        {__t("correggiperapplicareiservizi")}
                        <ul>
                            {erroriRicalcolo[preventivo.price.id].map((errore, indice) => {

                                return (
                                    <li key={indice}>{errore.message}</li>
                                )
                            })}
                        </ul>
                    </Alert>
                </BSSSnackbar>
                
            )}
        </Box>
    )
}

export default ErroriAddizionali;